// extracted by mini-css-extract-plugin
export default {"text":"HintAnotherFile_text__eZmaL"};